import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { trimScope } from '@bingads-webui-campaign-react/shell-ui-common';
import { getRoutePathById, findSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { tutorStepPropTypes } from './step-component-props';
import { LearnMore } from './learn-more';
import { StyledTutorialStep } from './tutorial-steps';
import helpConversionAudienceImage from '../../media/helpConversionAudience.png';

export const CreateAConversionGoalOrRemarketingList = (props) => {
  const {
    i18n, siteMap, scope, disableGoalLink,
  } = props;
  const accountQueryString = `?${scope.stringify()}`;
  const conversionGoalPagePath = disableGoalLink ? undefined : `${getRoutePathById(siteMap, 'conversion-goals')}${accountQueryString}`;
  const conversionGoalTemplate = i18n.getString(_TL_('On the {{a}}Conversion goals page{{/a}}, click {{b}}Create conversion goal{{/b}} and then define what action you want to track as a conversion.'));
  const conversionGoalHelpLabel = i18n.getString(_TL_('On the Conversion goals page, click Create conversion goal and then define what action you want to track as a conversion.'));

  const audienceLibraryPagePath = `${getRoutePathById(siteMap, 'audiences-library')}${accountQueryString}`;
  const audienceTemplate = i18n.getString(_TL_('You can also click {{b}}Create audience{{/b}} from the {{a}}Audiences page{{/a}} to define audiences based on actions people take on your website.'));
  const audienceHelpLabel = i18n.getString(_TL_('You can also click Create audience from the Audiences page to define audiences based on actions people take on your website.'));

  const handleClick = (e) => {
    e.preventDefault();
    const siteMapId = 'audiences-library';
    scope.history.push({
      pathname: getRoutePathById(siteMap, siteMapId),
      search: trimScope(findSiteMap(siteMap, s => s.id === siteMapId).scope, scope, siteMapId),
    });
  };

  const content = (
    <React.Fragment>
      <p>
        <ReactTemplate
          model={{
            b: text => (<b>{text}</b>),
            a: text => (<a href={conversionGoalPagePath} aria-label={text}>{text}</a>),
          }}
          template={conversionGoalTemplate}
        />
        <LearnMore i18n={i18n} topicId="ext56689" ariaLabel={conversionGoalHelpLabel} />
      </p>
      <p>
        <ReactTemplate
          model={{
            b: text => (<b>{text}</b>),
            a: text => (<a onClick={handleClick} href={audienceLibraryPagePath} aria-label={text}>{text}</a>),
          }}
          template={audienceTemplate}
        />
        <LearnMore i18n={i18n} topicId="app51222" ariaLabel={audienceHelpLabel} />
      </p>
    </React.Fragment>
  );

  return (
    <StyledTutorialStep
      title={i18n.getString(_TL_('Create a conversion goal or an audience'))}
      imageSrc={helpConversionAudienceImage}
      descTemp={content}
      i18n={i18n}
    />
  );
};

CreateAConversionGoalOrRemarketingList.propTypes = tutorStepPropTypes;
